import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1 4h3.185A2.995 2.995 0 0 0 7 6a2.995 2.995 0 0 0 2.815-2H19a1 1 0 1 0 0-2H9.815A2.995 2.995 0 0 0 7 0a2.995 2.995 0 0 0-2.815 2H1a1 1 0 1 0 0 2M19 9h-3.185A2.995 2.995 0 0 0 13 7a2.995 2.995 0 0 0-2.815 2H1a1 1 0 1 0 0 2h9.185A3 3 0 0 0 13 13a3 3 0 0 0 2.815-2H19a1 1 0 1 0 0-2M19 16H9.815A3 3 0 0 0 7 14a3 3 0 0 0-2.815 2H1a1 1 0 1 0 0 2h3.185A2.995 2.995 0 0 0 7 20a2.995 2.995 0 0 0 2.815-2H19a1 1 0 1 0 0-2" }, null, -1)
  ])))
}
export default { render: render }